import { render, staticRenderFns } from "./ConversationTabV2.vue?vue&type=template&id=6f9e4cda"
import script from "./ConversationTabV2.vue?vue&type=script&lang=js"
export * from "./ConversationTabV2.vue?vue&type=script&lang=js"
import style0 from "./ConversationTabV2.vue?vue&type=style&index=0&id=6f9e4cda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports